import format from 'date-fns/format'
import isValid from 'date-fns/isValid'
import es from 'date-fns/locale/es'

export function formatDate(date: string | undefined, formatOut = 'dd/MM/yyyy') {
  if (!date) return '-'
  if (!isValid(new Date(date))) return 'Invalid Date'

  return format(new Date(date), formatOut, { locale: es })
}

export function formatDateToString(date: Date) {
  return formatDate(date.toISOString(), 'yyyy-MM-dd')
}
